import { renderOutreachDraftHtml, type OutreachDraftContent } from '@aegislab/shared';
import { Button } from '@/shared/ui/atoms';
import * as s from './SendConfirmPanel.css';

export interface SendConfirmRecipientViewProps {
  content: OutreachDraftContent;
  /** 크리에이터가 여는 응답용 폼 주소. 캠페인에 폼이 없으면 `null`. */
  formUrl: string | null;
  /** 대표 이미지의 풀린 주소. */
  imageUrl: string | null;
  /** 본문 `{제품명}` 자리를 채울 값. */
  productName: string | null;
  onOpenPreview: () => void;
}

/**
 * 「받는 사람에게 보이는 모습」 — 승인 시안 ConfirmAfter **개선안**의 오른쪽 칸(2026-09-29).
 *
 * 되돌릴 수 없는 관문에서 마지막으로 보는 것은 숫자가 아니라 **크리에이터가 열었을 때의 모양**
 * 이다. 숫자는 왼쪽 확인 줄의 「받는 사람」 줄이 든다.
 *
 * **실제 메일 HTML 을 그대로 그린다.** 손으로 카드를 흉내 내면 두 가지가 어긋난다 — 메일은 흰
 * 바탕에 `#222` 글자인데(`render.ts` 의 `<body>`) 이 앱은 어두운 판이라 색이 다르고, 흉내 낸
 * 카드는 렌더러가 바뀔 때 같이 안 바뀐다. 같은 렌더러를 쓰면 여기 보이는 것이 곧 나가는 것이다.
 *
 * 링크는 열지 않는다(`linkMode: 'inert'`). iframe 은 스크립트도 이동도 막는다 — 본문이 사람이
 * 쓴 값이라 이 면이 실행 자리가 되면 안 된다. 「전체 미리보기」가 데스크톱·모바일 폭을 연다.
 *
 * 🔴 2026-09-29 에 이 자리에 「누구에게 가나」·「스티비 등록」을 세웠다가 걷었다(#2971). 시안의
 * **왼쪽이 「지금」** 이고 그것을 개선안으로 읽은 오독이었다 — 그 둘은 2026-09-23 판(`c195c6375`)
 * 이고 시안이 걷어내자고 한 쪽이다.
 */
export function SendConfirmRecipientView({
  content,
  formUrl,
  imageUrl,
  productName,
  onOpenPreview,
}: SendConfirmRecipientViewProps) {
  const html = renderOutreachDraftHtml(content, {
    formUrl,
    imageUrl,
    linkMode: 'inert',
    // 실제로는 스티비 수신거부 주소가 걸린다. 여기서는 어떤 링크도 만들지 않는다.
    unsubscribe: { note: '수신거부 Unsubscribe' },
    productName,
  });

  return (
    <section className={s.card} aria-labelledby="recipient-view-heading">
      <div className={s.recipientHead}>
        <h3 id="recipient-view-heading" className={s.heading}>
          받는 사람에게 보이는 모습
        </h3>
        <Button variant="ghost" size="xs" onClick={onOpenPreview}>
          전체 미리보기
        </Button>
      </div>

      <iframe title="받는 사람 화면" className={s.recipientFrame} sandbox="" srcDoc={html} />
    </section>
  );
}
